// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","9777":"recorder"}[chunkId] + "." + {"12":"cd4f5ee742b00568","9777":"80ad905560fd0830"}[chunkId] + ".js";
};